import Wix from './wix-sdk-polyfill';
import { fetchAndSetViewedMember } from '../state/members/actions';
import { getViewedMemberId } from '../state/members/selectors';

export default function listenToViewedUserChange(store) {
  Wix.addEventListener(Wix.Events.PAGE_NAVIGATION, (payload) => {
    const viewedUser = payload.routerData && payload.routerData.viewedUser;
    const viewedUserId = viewedUser && viewedUser.id;
    const isOtherUser = viewedUserId && viewedUserId !== getViewedMemberId(store.getState());

    // Refresh viewed user when a new one arrives
    if (isOtherUser) {
      store.dispatch(fetchAndSetViewedMember(viewedUserId));
    }
  });
}
